var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { useBoolState } from '@/hooks/state/useBoolState';
import { sleep } from '@/utils/async/sleep';
import { ANIMATION_TIME_FADE } from '@/utils/constants/ui/driver';
/**
 * Driver 表示要素制御
 */
export const useDriver = (options) => {
    const { isLastInitialize = false, scrollToTarget, unmountRef } = options;
    // オーバーレイ 表示制御
    const { boolState: isShow, changeFalse: hideOverlay, changeTrue: showOverlay, } = useBoolState();
    // 表示中の要素
    const [activeIndex, changeActiveIndex] = useState(0);
    /**
     * 表示中の要素 初期化
     */
    const reset = useCallback(() => changeActiveIndex(0), [changeActiveIndex]);
    /**
     * 表示開始
     * @param targetIndex 表示対象の settings の index
     */
    const start = useCallback((targetIndex = 0) => __awaiter(void 0, void 0, void 0, function* () {
        showOverlay();
        yield sleep(ANIMATION_TIME_FADE);
        if (!unmountRef.current) {
            scrollToTarget(targetIndex);
        }
    }), [scrollToTarget, showOverlay, unmountRef]);
    /**
     * 表示終了
     */
    const stop = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        hideOverlay();
        // 表示中の要素 初期化
        if (isLastInitialize) {
            yield sleep(ANIMATION_TIME_FADE);
            if (!unmountRef.current) {
                reset();
            }
        }
    }), [hideOverlay, isLastInitialize, reset, unmountRef]);
    return {
        activeIndex,
        changeActiveIndex,
        isShow,
        reset,
        start,
        stop,
    };
};
